import { WifiOff } from "lucide-react";
import { useOnline } from "@/lib/pwa";

export const OfflineBanner = () => {
  const online = useOnline();
  if (online) return null;
  return (
    <div className="flex items-center justify-center gap-2 bg-slate-900 px-4 py-1.5 text-xs font-medium text-amber-200" data-testid="offline-banner" role="status">
      <WifiOff size={13} /> You're offline — showing saved data. Bookings, uploads and approvals will work again once you're connected.
    </div>
  );
};
